var $ = require('jquery');

$(function () {

    $('.trending-insights__list').slick({
        arrows: true,
        centerPadding: '30px',
        mobileFirst: true,
        responsive: [{
            breakpoint: 767,
            settings: 'unslick'
        }],
        rtl: window.GenericUtilities.isRTL()
    });
    // to get slick slider to initialize on screen resize
    // https://github.com/kenwheeler/slick/issues/1730
    $(window).on('resize orientationchange', function () {
        $('.trending-insights__list').slick('resize');
    });

    $('.trending-insights__insight__image').each(function () {
        if ($(this).find('img').length == 0) {
            $(this).addClass('no-image');
        }
    });
});
